module.exports = __webpack_public_path__ + "static/media/iPhone14_1.33a13eab.png";